import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
    let authRequest = req;
    if (authRequest.responseType === 'json' && !authRequest.url.split('/').includes('i18n')) {
        authRequest = authRequest.clone({
          responseType: 'text'
        });
    }

    // Xử lý authRequestuest
    return next(authRequest).pipe(
        tap((response: any) => {
          if (response.body && typeof response.body === 'string') {
            response.body = JSON.parse(response.body)
          }
        }),
        catchError((error) => {
          return throwError(() => error);
        })
    )
};
